import { render } from "./Wheelspin.vue?vue&type=template&id=f63d34da&scoped=true&ts=true"
import script from "./Wheelspin.vue?vue&type=script&lang=ts"
export * from "./Wheelspin.vue?vue&type=script&lang=ts"

import "./Wheelspin.vue?vue&type=style&index=0&id=f63d34da&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Spark/Spark/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63d34da"]])

export default __exports__